import React, { useState } from 'react'
import {
    LinearGauge,
    Scale,
    Tick,
    Label,
    RangeContainer,
    Range,
    ValueIndicator,
    SubvalueIndicator,
    Export,
    Title,
    Font,
} from 'devextreme-react/linear-gauge';
import { APIGetLoggerConnectionsModel } from "models/APIGetLoggerConnectionsModel";
import { Tooltip, ITooltipOptions } from 'devextreme-react/tooltip';
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-bootstrap/Modal'
import Dialog from '@mui/material/Dialog';
import MaterialButton from '@mui/material/Button';
import Chart, { Size, CommonSeriesSettings, Aggregation, ValueAxis, ArgumentAxis, Series, TickInterval, Point, CommonAxisSettings } from 'devextreme-react/chart';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useMobileContext } from '../../Context/ContextProvider'
import Loader from '../../Utils/Loader/NewLoader2025'

interface Data {
    date: Date;
    battery: number | null;
    signal: number | null;
}

interface Props {
    connectionsData: Array<APIGetLoggerConnectionsModel> | null
}


const NewSignalGauge: React.FC<Props> = ({ connectionsData }) => {



    //STATE
    const [signalGraphToggle, setSignalGraphToggle] = useState<boolean>(false)


    const isMobile = useMobileContext()
    let minSignal = 32;
    let maxSignal = 0;
    let avgSignal = 0;
    let numberOfConnections = 0
    let valueColor = "";
    if (connectionsData && connectionsData.length > 0) {
        for (let i = 0; i < connectionsData.length; i++) {
            if (connectionsData[i].latestRssi !== 0) {
                if (connectionsData[i].latestRssi < minSignal) {
                    minSignal = connectionsData[i].latestRssi
                }
                if (connectionsData[i].latestRssi > maxSignal) {
                    maxSignal = connectionsData[i].latestRssi
                }
                avgSignal += connectionsData[i].latestRssi
                numberOfConnections++
            }
        }
        avgSignal = avgSignal / numberOfConnections

        if (avgSignal < 3) {
            valueColor = '#F5564A'
        } else if (avgSignal < 8) {
            valueColor = '#FA8F35'
        } else if (avgSignal < 13) {
            valueColor = '#FFC720'
        } else if (avgSignal < 18) {
            valueColor = '#CBC83E'
        } else {
            valueColor = '#97C95C'
        }
    }
    const subValues = [minSignal, maxSignal];


    return (
        <>
            {(!connectionsData || connectionsData?.length === 0) ?
                <div style={{
                    position: 'relative', left: 'Calc(50% - 100px)', top: '20%', minHeight: "200px"
                }}>
                    <Loader color={undefined} />
                </div>
                :
                <div style={{ display: "flex", flexDirection: "column" }} onClick={(): void => setSignalGraphToggle(!signalGraphToggle) }>
                    {isMobile ? <h3 style={{ textAlign: "center" }}><b><FormattedMessage id="Signal Info" /></b></h3> : <h5 style={{ textAlign: "center" }}><b><FormattedMessage id="Signal Info" /></b></h5>}
                    <p style={{ fontSize: isMobile ? '18px': 'inherit', textAlign: "center", marginBottom: "-10px" }}><FormattedMessage id="Arrows show last 7 day range" /></p>
                    <div style={{ display: "flex", justifyContent: 'center' }}>
                        <LinearGauge
                            id="gauge"
                            value={avgSignal}
                            subvalues={subValues}
                            width={250 }
                            
                        >
                            <Scale startValue={0} endValue={32} tickInterval={5}>
                                <Tick color="black" />
                            </Scale>
                            <RangeContainer>
                                <Range startValue={18} endValue={32} />
                                <Range startValue={13} endValue={18} />
                                <Range startValue={8} endValue={13} />
                                <Range startValue={3} endValue={8} />
                                <Range startValue={0} endValue={3} />
                            </RangeContainer>
                            
                            <ValueIndicator offset={10} color={valueColor} width={10} id="valueIndicator" />

                            
                            <SubvalueIndicator offset={-20} color={'black'} />
                        </LinearGauge>
                            
                    </div>
                    <p style={{ margin: "8px 0 16px 0" }}>
                        <FormattedMessage id="Average signal level for the last 7 days" />
                    </p>
                </div>}     
        </>
    )
}
export default NewSignalGauge